
export const environment = {
  production: true,
  baseUrl: `https://${window.location.hostname}`
};
